export default __webpack_public_path__ + "img/table_benefits-948d9305a096d9a5f79954990df33e39.jpg";